import { createSlice } from "@reduxjs/toolkit";

const clashDetailsSlice = createSlice({
  name: "clashDetails",
  initialState: {},
  reducers: {
    setClashDetails: (_state, action) => ({ ...action.payload }),
    setClashSettings: (_state, action) => ({ ..._state, settings: { ..._state?.settings, ...action.payload } }),
  },
});

export const { setClashDetails, setClashSettings } = clashDetailsSlice.actions;

export const clashDetails = clashDetailsSlice.reducer;

export default {
  clashDetails,
};
